import { Injectable, Injector } from "@angular/core";
import { Publishing } from "./publishing";
import { SearchPublicationHistoryModel } from "src/app/shared/model/SearchPublicationHistory.model";
import { forkJoin } from "rxjs";
import { PublicationHistoryService } from "../publication-history/publication-history.service";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as moment from "moment";
import { PublicationHistoryItem } from "../publication-history/PagedPublicationHistoryList";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: "root",
})
export class PublicationPDFService {
  private publishing = new Publishing();
  private publicationHistoryService: PublicationHistoryService;

  constructor(public _injector: Injector) {
    this.publicationHistoryService = this._injector.get(
      PublicationHistoryService
    );
  }
  LoadProjectsSubmitted(publishingId: any, publishDate: string) {
    this.publishing.publishDate = publishDate;

    var searchModelProjENF = new SearchPublicationHistoryModel(
      publishingId,
      "ProjSubmitted",
      "ENF",
      undefined,
      undefined,
      null
    );
    var searchModelProjENFSiteVisits = new SearchPublicationHistoryModel(
      publishingId,
      "ProjSubmitted",
      "ENFSiteVisits",
      undefined,
      undefined,
      null
    );
    var searchModelProjEIR = new SearchPublicationHistoryModel(
      publishingId,
      "ProjSubmitted",
      "EIR",
      undefined,
      undefined,
      null
    );
    var searchModelProjNPC = new SearchPublicationHistoryModel(
      publishingId,
      "ProjSubmitted",
      "NPC",
      undefined,
      undefined,
      null
    );
    var searchModelProjSRPR = new SearchPublicationHistoryModel(
      publishingId,
      "ProjSubmitted",
      "SRPR",
      undefined,
      undefined,
      null
    );
    var searchModelProjUnderENF = new SearchPublicationHistoryModel(
      publishingId,
      "ProjUnderRev",
      "ENF",
      undefined,
      undefined,
      null
    );
    var searchModelProjUnderEIR = new SearchPublicationHistoryModel(
      publishingId,
      "ProjUnderRev",
      "EIR",
      undefined,
      undefined,
      null
    );
    var searchModelProjUnderNPC = new SearchPublicationHistoryModel(
      publishingId,
      "ProjUnderRev",
      "NPC",
      undefined,
      undefined,
      null
    );
    var searchModelProjUnderSRPR = new SearchPublicationHistoryModel(
      publishingId,
      "ProjUnderRev",
      "SRPR",
      undefined,
      undefined,
      null
    );
    var searchModelSecretaryCertENF = new SearchPublicationHistoryModel(
      publishingId,
      "SecretaryCert",
      "ENF",
      undefined,
      undefined,
      null
    );
    var searchModelSecretaryCertEIR = new SearchPublicationHistoryModel(
      publishingId,
      "SecretaryCert",
      "EIR",
      undefined,
      undefined,
      null
    );
    var searchModelSecretaryCertNPC = new SearchPublicationHistoryModel(
      publishingId,
      "SecretaryCert",
      "NPC",
      undefined,
      undefined,
      null
    );
    var searchModelSecretaryCertROD = new SearchPublicationHistoryModel(
      publishingId,
      "SecretaryCert",
      "ROD",
      undefined,
      undefined,
      null
    );
    var searchModelSecretaryCertSRP = new SearchPublicationHistoryModel(
      publishingId,
      "SecretaryCert",
      "SRP",
      undefined,
      undefined,
      null
    );
    var searchModelSecretaryCertPBN = new SearchPublicationHistoryModel(
      publishingId,
      "SecretaryCert",
      "PBN",
      undefined,
      undefined,
      null
    );
    var searchModelSecretaryCertAO = new SearchPublicationHistoryModel(
      publishingId,
      "SecretaryCert",
      "AO",
      undefined,
      undefined,
      null
    );
    var searchModelRequestAO = new SearchPublicationHistoryModel(
      publishingId,
      "RequestAO",
      "",
      undefined,
      undefined,
      null
    );
    var searchModelPublicNotices = new SearchPublicationHistoryModel(
      publishingId,
      "PublicNotices",
      "",
      undefined,
      undefined,
      null
    );

    forkJoin([
      this.publicationHistoryService.GetPublicationHistoryList(
        searchModelProjENF
      ),
      this.publicationHistoryService.GetPublicationHistoryList(
        searchModelProjENFSiteVisits
      ),
      this.publicationHistoryService.GetPublicationHistoryList(
        searchModelProjEIR
      ),
      this.publicationHistoryService.GetPublicationHistoryList(
        searchModelProjNPC
      ),
      this.publicationHistoryService.GetPublicationHistoryList(
        searchModelProjSRPR
      ),
      this.publicationHistoryService.GetPublicationHistoryList(
        searchModelProjUnderENF
      ),
      this.publicationHistoryService.GetPublicationHistoryList(
        searchModelProjUnderEIR
      ),
      this.publicationHistoryService.GetPublicationHistoryList(
        searchModelProjUnderNPC
      ),
      this.publicationHistoryService.GetPublicationHistoryList(
        searchModelProjUnderSRPR
      ),
      this.publicationHistoryService.GetPublicationHistoryList(
        searchModelSecretaryCertENF
      ),
      this.publicationHistoryService.GetPublicationHistoryList(
        searchModelSecretaryCertEIR
      ),
      this.publicationHistoryService.GetPublicationHistoryList(
        searchModelSecretaryCertNPC
      ),
      this.publicationHistoryService.GetPublicationHistoryList(
        searchModelSecretaryCertROD
      ),
      this.publicationHistoryService.GetPublicationHistoryList(
        searchModelSecretaryCertSRP
      ),
      this.publicationHistoryService.GetPublicationHistoryList(
        searchModelSecretaryCertPBN
      ),
      this.publicationHistoryService.GetPublicationHistoryList(
        searchModelSecretaryCertAO
      ),
      this.publicationHistoryService.GetPublicationHistoryList(
        searchModelRequestAO
      ),
      this.publicationHistoryService.GetPublicationHistoryList(
        searchModelPublicNotices
      ),
    ]).subscribe(
      ([
        pagedPublicationHistoryList,
        publicationProjENFSiteVisits,
        publicationProjEIR,
        publicationProjNPC,
        publicationProjSRPR,
        publicationProjUnderENF,
        publicationProjUnderEIR,
        publicationProjUnderNPC,
        publicationProjUnderSRPR,
        publicationSecretaryCertENF,
        publicationSecretaryCertEIR,
        publicationSecretaryCertNPC,
        publicationSecretaryCertROD,
        publicationSecretaryCertSRP,
        publicationSecretaryCertPBN,
        publicationSecretaryCertAO,
        publicationRequestAO,
        publicationPublicNotices,
      ]) => {
        this.publishing.ProjectsSubmittedENF = pagedPublicationHistoryList.list;
        this.publishing.ProjectsSubmittedENFSiteVisits =
          publicationProjENFSiteVisits.list;
        this.publishing.ProjectsSubmittedEIR = publicationProjEIR.list;
        this.publishing.ProjectsSubmittedNPC = publicationProjNPC.list;
        this.publishing.ProjectsSubmittedSRPR = publicationProjSRPR.list;
        this.publishing.ProjectsUnderENF = publicationProjUnderENF.list;
        this.publishing.ProjectsUnderEIR = publicationProjUnderEIR.list;
        this.publishing.ProjectsUnderNPC = publicationProjUnderNPC.list;
        this.publishing.ProjectsUnderSRPR = publicationProjUnderSRPR.list;
        this.publishing.SecretaryCertENF = publicationSecretaryCertENF.list;
        this.publishing.SecretaryCertEIR = publicationSecretaryCertEIR.list;
        this.publishing.SecretaryCertNPC = publicationSecretaryCertNPC.list;
        this.publishing.SecretaryCertROD = publicationSecretaryCertROD.list;
        this.publishing.SecretaryCertSRP = publicationSecretaryCertSRP.list;
        this.publishing.SecretaryCertPBN = publicationSecretaryCertPBN.list;
        this.publishing.SecretaryCertAO = publicationSecretaryCertAO.list;
        this.publishing.publicationRequestAO = publicationRequestAO.list;
        this.publishing.publicationPublicNotices =
          publicationPublicNotices.list;

        this.ShowPreviewPDF();
      }
    );
  }

  ShowPreviewPDF() {
    const documentDefinition = this.getDocumentDefinition();
    pdfMake.createPdf(documentDefinition).open();
  }

  getDocumentDefinition() {
    return {
      content: [
        {
          text: "Environmental Monitor Preview",
          bold: true,
          fontSize: 20,
          alignment: "left",
          margin: [0, 0, 0, 20],
        },
        {
          text:
            "Publish Date:" +
            moment(this.publishing.publishDate, "YYYY-MM-DD h:m:s a").format(
              "MM/DD/YYYY"
            ),
          fontSize: 15,
          alignment: "left",
          margin: [0, 0, 0, 20],
        },
        {
          text: "Environmental Notification Forms",
          bold: true,
          fontSize: 12,
          style: "header",
        },
        this.GetProjSubmittedNODocumentType(
          this.publishing.ProjectsSubmittedENF
        ),
        {
          text: "Projects Submitted - Site Visits",
          bold: true,
          fontSize: 12,
          style: "header",
          margin: [0, 10, 0, 0],
        },
        this.GetProjSubmittedSiteVisits(
          this.publishing.ProjectsSubmittedENFSiteVisits
        ),
        {
          text: "Projects Submitted - Environmental Impact Reports",
          bold: true,
          fontSize: 12,
          style: "header",
          margin: [0, 10, 0, 0],
        },
        this.GetProjSubmittedDocType(this.publishing.ProjectsSubmittedEIR),
        {
          text: "Projects Submitted - Notices of Project Change",
          bold: true,
          fontSize: 12,
          style: "header",
          margin: [0, 10, 0, 0],
        },
        this.GetProjSubmittedNODocumentType(
          this.publishing.ProjectsSubmittedNPC
        ),
        {
          text: "Projects Submitted - Special Review Procedure Request",
          bold: true,
          fontSize: 12,
          style: "header",
          margin: [0, 10, 0, 0],
        },
        this.GetProjSubmittedNODocumentType(
          this.publishing.ProjectsSubmittedSRPR
        ),
        {
          text: "Projects Under Review - Environmental Notification Forms",
          bold: true,
          fontSize: 12,
          style: "header",
          margin: [0, 10, 0, 0],
        },
        this.GetProjSubmittedNODocumentType(this.publishing.ProjectsUnderENF),
        {
          text: "Projects Under Review - Environmental Impact Reports",
          bold: true,
          fontSize: 12,
          style: "header",
          margin: [0, 10, 0, 0],
        },
        this.GetProjSubmittedDocType(this.publishing.ProjectsUnderEIR),
        {
          text: "Projects Under Review - Notices of Project Change",
          bold: true,
          fontSize: 12,
          style: "header",
          margin: [0, 10, 0, 0],
        },
        this.GetProjSubmittedNODocumentType(this.publishing.ProjectsUnderNPC),
        {
          text: "Projects Under Review - Special Review Procedure Request",
          bold: true,
          fontSize: 12,
          style: "header",
          margin: [0, 10, 0, 0],
        },
        this.GetProjSubmittedNODocumentType(this.publishing.ProjectsUnderSRPR),
        {
          text: "Secretary's Certificates - Environmental Notification Forms",
          bold: true,
          fontSize: 12,
          style: "header",
          margin: [0, 10, 0, 0],
        },
        this.GetSecretaryCertNODocType(this.publishing.SecretaryCertENF),
        {
          text: "Secretary's Certificates - Environmental Impact Reports",
          bold: true,
          fontSize: 12,
          style: "header",
          margin: [0, 10, 0, 0],
        },
        this.GetSecretaryCertDocType(this.publishing.SecretaryCertEIR),
        {
          text: "Secretary's Certificates - Notices of Project Change",
          bold: true,
          fontSize: 12,
          style: "header",
          margin: [0, 10, 0, 0],
        },
        this.GetSecretaryCertNODocType(this.publishing.SecretaryCertNPC),
        {
          text: "Secretary's Certificates - Records of Decision",
          bold: true,
          fontSize: 12,
          style: "header",
          margin: [0, 10, 0, 0],
        },
        this.GetSecretaryCertComments(this.publishing.SecretaryCertROD),
        {
          text: "Secretary's Certificates - Special Review Procedures",
          bold: true,
          fontSize: 12,
          style: "header",
          margin: [0, 10, 0, 0],
        },
        this.GetSecretaryCertDocType(this.publishing.SecretaryCertSRP),
        {
          text: "Secretary's Certificates - Public Benefits Determinations",
          bold: true,
          fontSize: 12,
          style: "header",
          margin: [0, 10, 0, 0],
        },
        this.GetSecretaryCertNODocType(this.publishing.SecretaryCertPBN),
        {
          text: "Secretary's Certificates - Advisory Opinions",
          bold: true,
          fontSize: 12,
          style: "header",
          margin: [0, 10, 0, 0],
        },
        this.GetSecCertAdvisoryOpinion(this.publishing.SecretaryCertAO),
        {
          text: "Requests for Advisory Opinions",
          bold: true,
          fontSize: 12,
          style: "header",
          margin: [0, 10, 0, 0],
        },
        this.GetRequestsForAdvisoryOpinion(
          this.publishing.publicationRequestAO
        ),
        {
          text: "Public Notices",
          bold: true,
          fontSize: 12,
          style: "header",
          margin: [0, 10, 0, 0],
        },
        this.GetPublicNotices(this.publishing.publicationPublicNotices),
      ],
    };
  }

  GetProjSubmittedNODocumentType(
    publicationHistoryList: PublicationHistoryItem[]
  ) {
    return {
      table: {
        widths: ["*", 50, "auto", "auto", "auto", 90, 100],
        body: [
          [
            {
              text: "EEA No.",
              style: "tableHeader",
            },
            {
              text: "Project Name",
              style: "tableHeader",
            },
            {
              text: "Municipality",
              style: "tableHeader",
            },
            {
              text: "Document Type",
              style: "tableHeader",
            },
            {
              text: "Comments Due",
              style: "tableHeader",
            },
            {
              text: "For Copies",
              style: "tableHeader",
            },
            {
              text: "MEPA Analyst",
              style: "tableHeader",
            },
          ],
          ...publicationHistoryList.map((ps) => {
            return [
              ps.eeaNumber,
              ps.projectName,
              ps.municipalId,
              ps.type,
              this.ValidateCommentsDue(ps),
              ps.forCopies.split(",").join("\n"),
              ps.mepaAnalyst.split(", N/A").join("\n"),
            ];
          }),
        ],
      },
    };
  }

  ValidateCommentsDue(publicationHistoryItem: PublicationHistoryItem): string {
    if (publicationHistoryItem.withdrawn == true) {
      return "Withdrawn";
    }
    if (this.IsNullOrUndefined(publicationHistoryItem.commentsDue)) {
      return "NA";
    }
    var { DateTime } = require("luxon");
    var dueDate = DateTime.fromISO(publicationHistoryItem.commentsDue);
    return dueDate.toFormat("MM/dd/yyyy");
  }

  public IsNullOrUndefined(variable: any): boolean {
    return variable === null || variable === undefined || variable === "";
  }

  GetProjSubmittedSiteVisits(
    projectsSubmittedENFSiteVisits: PublicationHistoryItem[]
  ) {
    return {
      table: {
        widths: ["*", "auto", "auto", 100, "auto", "auto"],
        body: [
          [
            {
              text: "EEA No.",
              style: "tableHeader",
            },
            {
              text: "Project Name",
              style: "tableHeader",
            },
            {
              text: "Municipality",
              style: "tableHeader",
            },
            {
              text: "Meeting Date",
              style: "tableHeader",
            },
            {
              text: "Meeting Time",
              style: "tableHeader",
            },
            {
              text: "Location",
              style: "tableHeader",
            },
          ],
          ...projectsSubmittedENFSiteVisits.map((ps) => {
            return [
              ps.eeaNumber,
              ps.projectName,
              ps.municipalId,
              moment(ps.time, "YYYY-MM-DD h:m:s a").format("MM/DD/YYYY"),
              moment(ps.time, "YYYY-MM-DD h:m:s a").format("h:mm a"),
              ps.location,
            ];
          }),
        ],
      },
    };
  }

  GetProjSubmittedDocType(projectsSubmittedEIR: PublicationHistoryItem[]) {
    return {
      table: {
        widths: ["*", 60, "auto", "auto", "auto", 90, 100],
        body: [
          [
            {
              text: "EEA No.",
              style: "tableHeader",
            },
            {
              text: "Project Name",
              style: "tableHeader",
            },
            {
              text: "Municipality",
              style: "tableHeader",
            },
            {
              text: "Document Type",
              style: "tableHeader",
            },
            {
              text: "Comments Due",
              style: "tableHeader",
            },
            {
              text: "For Copies",
              style: "tableHeader",
            },
            {
              text: "MEPA Analyst",
              style: "tableHeader",
            },
          ],
          ...projectsSubmittedEIR.map((ps) => {
            return [
              ps.eeaNumber,
              ps.projectName,
              ps.municipalId,
              ps.type,
              this.ValidateCommentsDue(ps),
              ps.forCopies.split(",").join("\n"),
              ps.mepaAnalyst.split(", N/A").join("\n"),
            ];
          }),
        ],
      },
    };
  }

  GetSecretaryCertNODocType(publicationHistoryItem: PublicationHistoryItem[]) {
    return {
      table: {
        widths: ["auto", "auto", "auto", "auto", "auto", "auto"],
        body: [
          [
            {
              text: "EEA No.",
              style: "tableHeader",
            },
            {
              text: "Project Name",
              style: "tableHeader",
            },
            {
              text: "Municipality",
              style: "tableHeader",
            },
            {
              text: "Document Type",
              style: "tableHeader",
            },
            {
              text: "Action",
              style: "tableHeader",
            },
            {
              text: "Action Date",
              style: "tableHeader",
            },
          ],
          ...publicationHistoryItem.map((ps) => {
            return [
              ps.eeaNumber,
              ps.projectName,
              ps.municipalId,
              ps.type,
              ps.action,
              moment(ps.time, "YYYY-MM-DD h:m:s a").format("MM/DD/YYYY"),
            ];
          }),
        ],
      },
    };
  }

  GetSecretaryCertComments(publicationHistoryList: PublicationHistoryItem[]) {
    return {
      table: {
        widths: ["auto", "auto", "auto", "auto", "auto", "auto", "auto"],
        body: [
          [
            {
              text: "EEA No.",
              style: "tableHeader",
            },
            {
              text: "Project Name",
              style: "tableHeader",
            },
            {
              text: "Municipality",
              style: "tableHeader",
            },
            {
              text: "Document Type",
              style: "tableHeader",
            },
            {
              text: "Comments Due",
              style: "tableHeader",
            },
            {
              text: "Action",
              style: "tableHeader",
            },
            {
              text: "Action Date",
              style: "tableHeader",
            },
          ],
          ...publicationHistoryList.map((ps) => {
            return [
              ps.eeaNumber,
              ps.projectName,
              ps.municipalId,
              ps.type,
              this.ValidateCommentsDue(ps),
              ps.action,
              moment(ps.time, "YYYY-MM-DD h:m:s a").format("MM/DD/YYYY"),
            ];
          }),
        ],
      },
    };
  }

  GetSecretaryCertDocType(publicationHistoryItem: PublicationHistoryItem[]) {
    return {
      table: {
        widths: ["auto", "auto", "auto", "auto", "auto", "auto"],
        body: [
          [
            {
              text: "EEA No.",
              style: "tableHeader",
            },
            {
              text: "Project Name",
              style: "tableHeader",
            },
            {
              text: "Municipality",
              style: "tableHeader",
            },
            {
              text: "Document Type",
              style: "tableHeader",
            },
            {
              text: "Action",
              style: "tableHeader",
            },
            {
              text: "Action Date",
              style: "tableHeader",
            },
          ],
          ...publicationHistoryItem.map((ps) => {
            return [
              ps.eeaNumber,
              ps.projectName,
              ps.municipalId,
              ps.type,
              ps.action,
              moment(ps.time, "YYYY-MM-DD h:m:s a").format("MM/DD/YYYY"),
            ];
          }),
        ],
      },
    };
  }

  GetSecCertAdvisoryOpinion(publicationHistoryList: PublicationHistoryItem[]) {
    return {
      table: {
        widths: ["auto", "auto", "auto", "auto", "auto"],
        body: [
          [
            {
              text: "EEA No.",
              style: "tableHeader",
            },
            {
              text: "Project Name",
              style: "tableHeader",
            },
            {
              text: "Municipality",
              style: "tableHeader",
            },
            {
              text: "Action",
              style: "tableHeader",
            },
            {
              text: "Action Date",
              style: "tableHeader",
            },
          ],
          ...publicationHistoryList.map((ps) => {
            return [
              ps.eeaNumber,
              ps.projectName,
              ps.municipalId,
              ps.action,
              moment(ps.time, "YYYY-MM-DD h:m:s a").format("MM/DD/YYYY"),
            ];
          }),
        ],
      },
    };
  }

  GetRequestsForAdvisoryOpinion(
    publicationHistoryList: PublicationHistoryItem[]
  ) {
    return {
      table: {
        widths: ["auto", "auto", "auto", "auto"],
        body: [
          [
            {
              text: "Project Name",
              style: "tableHeader",
            },
            {
              text: "Municipality",
              style: "tableHeader",
            },
            {
              text: "Comments Due",
              style: "tableHeader",
            },
            {
              text: "MEPA Analyst",
              style: "tableHeader",
            },
          ],
          ...publicationHistoryList.map((ps) => {
            return [
              ps.projectName,
              ps.municipalId,
              this.ValidateCommentsDue(ps),
              ps.mepaAnalyst,
            ];
          }),
        ],
      },
    };
  }

  GetPublicNotices(publicationHistory: PublicationHistoryItem[]) {
    return {
      table: {
        widths: ["auto", "auto", "auto"],
        body: [
          [
            {
              text: "Notice Type",
              style: "tableHeader",
            },
            {
              text: "Municipality",
              style: "tableHeader",
            },
            {
              text: "Agency",
              style: "tableHeader",
            },
          ],
          ...publicationHistory.map((ps) => {
            return [ps.noticeType, ps.municipalId, ps.agency];
          }),
        ],
      },
    };
  }
}
